import React from 'react';
import DangerAlert from '@assets/images/danger_blank.svg';
import { Alert, Box, Typography } from '@mui/material';
import { alpha } from '@mui/material/styles';
import { useLanguage } from 'Context/LanguageContext';
import RoleUtils from 'FielderUtils/roles/roleUtils';

const NonPaymentWarning = ({ nonPaymentCounter, user }) => {
  const lan = useLanguage();
  if (RoleUtils.isUserClient(user)) {
    return null;
  }
  const dayLabel = nonPaymentCounter === 1 ? lan.day : lan.days;
  return (
    <Alert
      severity='warning'
      variant='outlined'
      icon={
        <Box
          component='img'
          src={DangerAlert}
          alt=''
          sx={{ width: 28, height: 28 }}
        />
      }
      sx={{
        alignItems: 'center',
        borderColor: (theme) => alpha(theme.palette.warning.main, 0.4),
        backgroundColor: (theme) =>
          theme.palette.mode === 'dark'
            ? alpha(theme.palette.warning.main, 0.12)
            : alpha(theme.palette.warning.main, 0.08),
        color: 'text.primary',
        py: 1.5,
        '& .MuiAlert-icon': {
          mr: 2,
        },
      }}
    >
      <Typography component='span' variant='body2'>
        {lan.billingAlertNotPaid1}{' '}
        {nonPaymentCounter} {dayLabel}{' '}
        {lan.billingAlertNotPaid2}
      </Typography>
    </Alert>
  );
};
export default NonPaymentWarning;
//Original code:
/*import React from 'react';
import DangerAlert from '@assets/images/danger_blank.svg';
import { useLanguage } from 'Context/LanguageContext';
import RoleUtils from 'FielderUtils/roles/roleUtils';
import Grid from '@mui/material/Grid2';

const NonPaymentWarning = ({ nonPaymentCounter, user }) => {
	const lan = useLanguage();
	return (
		<>
			{!RoleUtils.isUserClient(user) ? (
				<Grid container className='TopMenu-alert'>
					<Grid size={12} className='Top-menu-alert-text mx-auto'>
						{nonPaymentCounter === 1 ? (
							<div className='mt3'>
								<img src={DangerAlert} className='Top-menu-alert-img' alt='' />
								{lan.billingAlertNotPaid1}
								{nonPaymentCounter} {lan.day}
								{lan.billingAlertNotPaid2}
							</div>
						) : (
							<div className='mt-3'>
								<img src={DangerAlert} className='Top-menu-alert-img' alt='' />
								{lan.billingAlertNotPaid1}
								{nonPaymentCounter} {lan.days}
								{lan.billingAlertNotPaid2}
							</div>
						)}
					</Grid>
				</Grid>
			) : null}
		</>
	);
};

export default NonPaymentWarning;
*/
